<template>
  <div class="assets" v-loading="loading">
    <!-- <div class="spaceLeft">
      <img
        src="@/assets/image/profile/img-1.png"
        style="width:0.88rem;margin-right:0.16rem;"
      />
      <div>
        <div class="text-1" style="margin-bottom: 0.16rem;">My Assets</div>
        <div class="text-2">
          <big-number :number="myAssets"/>
          TCash
        </div>
      </div>
    </div> -->
    <el-row :gutter="28">
      <el-col :xs="24" :sm="24" :md="8" :lg="8">
        <div class="common-card">
          <div class="common-card-main">
            <div class="spaceLeft card-text-1" style="margin-bottom:0.2rem;justify-content: space-between;">
              <span> <i class="iconfont trn-balance" />
                Max borrowable amount
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="Based on your recent TAT minting records,this is the maximum TCash you can borrow."
                  placement="top"
                >
                  <i class="el-icon-question" style="font-size: 0.16rem;color: #929DAD;margin-left: 0.08rem;cursor: pointer;"></i>
                </el-tooltip>
              </span>
              <span style="font-size: 0.16rem;color: #225BFC;margin-left: 0.1rem;cursor: pointer;"
                @click="handleLearnMore">
                Learn more
              </span>
            </div>
            <div class="card-text-2">
              <span>
                <span style="color: #FFFFFF;font-size: 0.24rem;" v-if="!isEligible">Not eligible</span>
                <big-number v-else :number.sync="balance.PCL" :count="2" />
              </span>
              <!-- <span class="unit">TCash</span> -->
            </div>
            <!-- <el-button
              type="primary"
              class="spaceLeft"
              @click="$router.push('/TCashFinance/exchange')"
            >
              <i class="iconfont trn-exchange" style="font-size: 0.16rem;"/>
              Exchange TCash
            </el-button> -->
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="8" :lg="8">
        <div class="common-card">
          <div class="common-card-main">
            <div class="spaceLeft card-text-1" style="margin-bottom:0.2rem;justify-content: space-between;">
              <span style="display: flex;align-items: center;">
                <img src="@/assets/image/profile/RemainingBorrowableAmount.png"
                  style="width:0.24rem;margin-right:0.1rem;" />
                Remaining borrowable amount
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="Max borrowable-Outstanding"
                  placement="top"
                >
                  <i class="el-icon-question" style="font-size: 0.16rem;color: #929DAD;margin-left: 0.08rem;cursor: pointer;"></i>
                </el-tooltip>
              </span>
              <!-- <span style="font-size: 0.16rem;color: #225BFC;margin-left: 0.1rem;">
                Learn more
              </span> -->
            </div>
            <div class="card-text-2">
              <span><big-number :number.sync="balance.ALB" :count="2" /></span>
              <!-- <span class="unit">TCash</span> -->
            </div>
            <!-- <el-button
              type="primary"
              @click="$router.push('/TCashFinance/deposit')"
            >
              Deposit
            </el-button>
            <el-button type="primary" @click="$router.push('/TCashFinance/deposit?withdraw=1')">
              <i class="iconfont trn-withdraw" style="font-size: 0.16rem;"/>
              Withdraw
            </el-button> -->
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="8" :lg="8">
        <div class="common-card">
          <div class="common-card-main">
            <div class="spaceBetween" style="margin-bottom:0.2rem;justify-content: space-between;">
              <div class="spaceLeft card-text-1">
                <span style="display: flex;align-items: center;">
                  <img src="@/assets/image/profile/TotalUnrepaid.png" style="width:0.24rem;margin-right:0.1rem;" />
                  Total Unrepaid
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="All your outstanding loans,including principal and interest excluding any excluding any repaid amount."
                    placement="top"
                  >
                    <i class="el-icon-question" style="font-size: 0.16rem;color: #929DAD;margin-left: 0.08rem;cursor: pointer;"></i>
                  </el-tooltip>
                </span>
              </div>
              <!-- <el-button
                type="text"
                @click="$router.push('/TCashFinance/lending?detail=1')"
              >Details <i class="el-icon-arrow-right"
              /></el-button> -->
            </div>
            <div class="card-text-2">
              <!-- <span><big-number :number.sync="calculateTLAMinusTRA" /></span> -->
              <span><big-number :number="calculateTLAMinusTRA()" :count="2" /></span>
              <!-- <span class="unit">TCash</span> -->
              <span v-if="showDueLoans">
                <span style="color: #D71817;font-size: 0.16rem;margin-left: 0.12rem;margin-right: 0.07rem;">{{
                  dueLoansCount }} loans due
                  soon</span>
                <span style="color: #FFFFFF;font-size: 0.16rem;">
                  Please
                  <span class="repay-now-btn"
                    style="color: #225BFC;font-size: 0.16rem;cursor: pointer;text-decoration: underline;font-weight: 600;padding: 0.04rem 0.08rem;transition: all 0.3s ease;"
                    @click="goToRepayPage" @mouseover="$event.target.style.backgroundColor = 'rgba(34, 91, 252, 0.1)'"
                    @mouseout="$event.target.style.backgroundColor = 'transparent'">repay now.</span>
                </span>
              </span>
            </div>
            <!-- <el-button
              type="primary"
              @click="$router.push('/TCashFinance/lending')"
            >
              Loan
            </el-button>

            <el-button type="primary" @click="$router.push('/TCashFinance/lending?detail=1')">
              <i class="iconfont trn-repayment" style="font-size: 0.16rem;"/>
              Repay
            </el-button> -->
            <!-- <el-button
              class="warn-btn"
              @click="$router.push('/TCashFinance/lending?detail=1')"
              v-if="warningTotal>0"
            >
              <el-tooltip
                class="item"
                effect="dark"
                :content="'You have '+ warningTotal +' loans whose pledge rate is lower than the warning line('+LoanPledgeRateWarningValue+'). Please replenish the collateral in time, otherwise it will be liquidated!'"
                placement="top"
                :disabled="warningTotal==0"
              >
                <span>
                  <svg class="icon" aria-hidden="true" v-if="warningTotal>0">
                    <use xlink:href="#trn-warn"></use>
                  </svg>
                  Add collateral
                </span>

              </el-tooltip>
            </el-button> -->
          </div>
        </div>
      </el-col>

      <el-col v-if="account" style="display: flex;justify-content: space-around;width: 100%;" :xs="24" :sm="24" :md="8"
        :lg="8">
        <div class="echat">
          <div ref="loanStatusChart" style="width: 100%; height: 4.5rem;"></div>
        </div>
        <div class="echat">
          <div ref="balanceChart" style="width: 100%; height: 4.5rem;"></div>
        </div>
      </el-col>
    </el-row>

    <!-- Learn More 弹窗 -->
    <el-dialog :visible.sync="dialogVisible" width="8rem" custom-class="learn-more-dialog">
      <template slot="title">
        <div class="dialog-custom-title">{{ learnMoreTitle }}</div>
      </template>
      <div class="learn-more-content">
        {{ learnMoreText }}


        <div v-if="learnMoreTitle == 'Value Source'">
          <div style="color: #225BFC;margin-top: 0.2rem;font-weight: 600;">How is credit measured?</div>
          <div style="color: #225BFC;margin-top: 0.1rem;font-weight: 600;">How is the max borrowable amount calculated?
          </div>
          <div style="color: #225BFC;margin-top: 0.1rem;font-weight: 600;">Learn more details </div>
        </div>
        <div v-else>
          <div style="color: #225BFC;margin-top: 0.2rem;font-weight: 600;">How to mint Rep？</div>
          <div style="color: #225BFC;margin-top: 0.1rem;font-weight: 600;">Learn more details </div>
        </div>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">Got it</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
import { overdraft } from "@/api/ustn/profile.js";
import { getLoadStatistic, loanList } from "@/api/ustn/loan.js";
import * as echarts from 'echarts';
import {
  toBigNum,
  toBigItem,
  toSmallNum,
  toSmallNumStr,
  fixed
} from "@/utils/bigNumberTran.js";

export default {
  components: {},
  data() {
    return {
      loading: false,
      balance: 0,
      depositeBalance: 0,
      overdraft: 0,
      warningTotal: 0,
      LoanPledgeRateWarningValue: "0",
      loadStatistic: {},
      loanStatusChart: null,
      balanceChart: null,
      isEligible: false,
      dialogVisible: false,
      TAT: null,
      TATAddress: null,
      dueLoansCount: 0,
      showDueLoans: false,
    };
  },
  computed: {
    account() {
      return this.$store.getters.metaMaskObj.account;
    },
    myAssets() {
      const x = new this.BigNumber(this.balance || 0);
      const y = new this.BigNumber(this.depositeBalance || 0);
      return x.plus(y);
    },
    learnMoreText() {
      if (!this.isEligible) {
        return "Your account hasn't minted REP at least twice, so its credit is currently too low to borrow TCash. Please mint REP at least twice before attempting to borrow TCash again.";
      } else if (this.balance && Number(toSmallNum(this.balance.PCL)) === 0) {
        return "Because we haven't found any record of your REP minting in the past 3 months, your TCash borrowable amount is currently 0.";
      } else {
        return "This value will fluctuate depending on the state of your credit.";
      }
    },
    learnMoreTitle() {
      if (!this.isEligible) {
        return "Why am l not eligible?";
      } else if (this.balance && Number(toSmallNum(this.balance.PCL)) === 0) {
        return "Why is there a 0 here?";
      } else {
        return "Value Source";
      }
    }
  },
  methods: {
    handleLearnMore() {
      this.dialogVisible = true;
    },
    goToRepayPage() {
      this.$router.push({
        path: '/TCashFinance/lending',
        query: {
          detail: '1',
          dueSoon: 'true'
        }
      });
    },
    initCharts() {
      // 初始化贷款状态图表
      this.loanStatusChart = echarts.init(this.$refs.loanStatusChart);
      const loanStatusOption = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)',
          position: ['50%', '50%'],
          backgroundColor: 'rgba(0, 26, 73, 0.9)',
          borderColor: 'rgba(255, 255, 255, 0.2)',
          borderWidth: 1,
          textStyle: {
            color: '#fff',
            fontSize: 14
          },
          extraCssText: 'box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);'
        },
        legend: {
          orient: 'horizontal',
          bottom: 0,
          left: 'center',
          textStyle: {
            color: '#fff'
          }
        },
        series: [
          {
            name: 'Loan Status',
            type: 'pie',
            radius: ['40%', '60%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 20,
              borderColor: '#001A49',
              borderWidth: 10
            },
            label: {
              show: true,
              position: 'outside',
              formatter: '{b}\n{c}',
              color: '#DCE0E7',
              fontWeight: 600,
              fontSize: "0.18rem"
            },
            labelLine: {
              show: true,
              length: 15,
              length2: 10,
              smooth: true,
              lineStyle: {
                color: '#ccc',
                width: 1
              }
            },
            data: [
              { value: this.loadStatistic.normal || 0, name: 'Normal', itemStyle: { color: '#52C41A' } },
              { value: this.loadStatistic.warning || 0, name: 'Warning', itemStyle: { color: '#FAAD14' } },
              { value: this.loadStatistic.liquidated || 0, name: 'Liquidated', itemStyle: { color: '#FF4D4F' } },
            ]
          }
        ]
      };

      // 初始化余额图表
      this.balanceChart = echarts.init(this.$refs.balanceChart);
      const balanceOption = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)',
          position: ['50%', '50%'],
          backgroundColor: 'rgba(0, 26, 73, 0.9)',
          borderColor: 'rgba(255, 255, 255, 0.2)',
          borderWidth: 1,
          textStyle: {
            color: '#fff',
            fontSize: 14
          },
          extraCssText: 'box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);'
        },
        legend: {
          orient: 'horizontal',
          bottom: 0,
          left: 'center',
          textStyle: {
            color: '#fff',
          }
        },
        series: [
          {
            name: 'Balance',
            type: 'pie',
            radius: ['40%', '60%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 20,
              borderColor: '#001A49',
              borderWidth: 10
            },
            label: {
              show: true,
              position: 'outside',
              formatter: function(params) {
                // 将数值格式化为两位小数
                const formattedValue = parseFloat(params.value).toFixed(2);
                return params.name + '\n' + formattedValue;
              },
              color: '#DCE0E7',
              fontWeight: 600,
              fontSize: "0.18rem"
            },
            labelLine: {
              show: true,
              length: 10,
              length2: 10,
              smooth: true,
              lineStyle: {
                color: '#ccc',
                width: 1
              }
            },
            data: [
            {
                value: toSmallNumStr(this.balance.TRA || 0, 18),
                name: 'Repaid',
                itemStyle: { color: '#722ED1', fontWeight: 600 }
              },
              {
                value: toSmallNumStr(this.calculateTLAMinusTRA(), 18),
                name: 'Unpaid',
                itemStyle: { color: '#1890FF', fontWeight: 600 }
              }
            
            ]
          }
        ]
      };

      this.loanStatusChart.setOption(loanStatusOption);
      this.balanceChart.setOption(balanceOption);
    },
    async init() {
      try {
        this.loading = true;
        this.exchangeNum = undefined;

        this.contractTCash = this.$store.getters.contractMap["contractTCash"].contract;
        this.contractTCashAddress = this.$store.getters.contractMap["contractTCash"].address;

        this.contractTCashLoan = this.$store.getters.contractMap["contractTCashLoan"].contract;
        this.contractTCashLoanAddress = this.$store.getters.contractMap["contractTCashLoan"].address;
        this.TAT = this.$store.getters.contractMap["contractTAT"].contract;
        this.TATAddress = this.$store.getters.contractMap["contractTAT"].address;
        // console.log('contractTCashLoan', this.contractTCashLoan);
        // this.contractGovernance = this.$store.getters.contractMap["contractGovernance"].contract;
        // this.contractParameterInfo = this.$store.getters.contractMap["contractParameterInfo"].contract;

        if (!this.$store.getters.metaMaskObj.account) {
          this.loading = false;
          return;
        }
        await this.getBalance();
        await this.checkEligibility();
        // await this.queryDepositBalance();
        // await this.getoverdraft();
        await this.getLoadStatistic();
        await this.getDueLoans();
        // await this.getLoanPledgeRateWarningValue();
        this.initCharts();
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    async checkEligibility() {
      try {
        // 这里可以调用相关API来检查用户是否有资格和是否铸造过TAT至少两次
        // 为了演示，我们使用余额.PCL来判断
        // this.isEligible = true; // 默认有资格
        // this.hasMintedTwice = true;

        // 这里添加检查逻辑
        // 如果需要，可以调用API或合约方法来获取用户是否铸造过TAT至少两次
        // 例如：


        const mintResult = await this.checkMintHistory(this.account);
        console.log('mintResult', mintResult);
        this.isEligible = mintResult;
      } catch (e) {
        console.log('检查资格出错:', e);
      }
    },
    async checkMintHistory(account) {
      const tatResult = await this.TAT.methods.getTATRecord(account).call();
      console.log('tatResult', tatResult);
      return tatResult.amounts.length >= 2;
    },
    async getLoadStatistic() {
      try {
        let res = await getLoadStatistic({
          account: this.$store.getters.metaMaskObj.account
        });
        console.log('getLoadStatistic', res);
        if (res.code == '0') {
          this.loadStatistic = res.result;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getLoanPledgeRateWarningValue() {
      try {
        let res = await this.contractParameterInfo.methods[
          "getUSTNLoanPledgeRateWarningValue"
        ]().call({
          from: this.$store.getters.metaMaskObj.account
        });
        this.LoanPledgeRateWarningValue = (res / 100) + "%";
      } catch (e) {
        console.log(e);
      }
    },
    async getBalance() {
      try {
        let balance = await this.contractTCashLoan.methods["getPersonalLoanData"](
          this.account
        ).call({
          from: this.account
        });
        const result = await this.contractTCashLoan.methods.getPersonalCreditAndAvailable(this.account).call();
        console.log('getPersonalCreditAndAvailableresult', result);
        // 解构返回值
        const PCL = result[0]; // 个人授信额度
        const ALB = result[1]; // 可贷余额
        balance.PCL = PCL;
        balance.ALB = ALB;
        // // console.log('getBalance',JSON.stringify(this.balance));
        // let PRFres = await this.contractTCashLoan.methods.getPRF(this.account).call({
        //   from: this.account
        // })
        // // console.log('PRFres', PRFres);
        // balance.PRF = PRFres;
        // // 使用call方法获取合约数据，而不是send方法
        // let SRFres = await this.contractTCashLoan.methods.getSRF().call({
        //   from: this.account
        // });
        // console.log('SRFres', SRFres);
        // balance.SRF = SRFres;
        this.balance = balance;
        console.log('balance', balance);
      } catch (e) {
        console.log(e);
      }
    },
    async queryDepositBalance() {
      try {
        this.depositeBalance = await this.contractUSTNFinance.methods[
          "queryDepositBalance"
        ]().call({
          from: this.account
        });
      } catch (e) {
        console.log(e);
      }
    },
    getoverdraft() {
      overdraft({
        account: this.$store.getters.metaMaskObj.account
      }).then(res => {
        this.overdraft = res.result || 0;
      });
    },
    calculateTLAMinusTRA() {
      try {
        if (!this.balance || !this.balance.TLA) return 0;

        // 使用与PCL和ALB相同的处理方式
        const TLA = new this.BigNumber(this.balance.TLA);
        const TRA = new this.BigNumber(this.balance.TRA || 0);

        // 使用BigNumber进行计算
        const result = TLA.minus(TRA);
        return result.isGreaterThanOrEqualTo(0) ? result.toString() : "0";
      } catch (e) {
        console.error('Error calculating TLA minus TRA:', e);
        return 0;
      }
    },
    async getDueLoans() {
      try {
        if (!this.account) return;

        // 计算一年前和当前时间的时间戳
        const dateTo = this.moment().valueOf();
        const dateFrom = this.moment().subtract(1, 'year').valueOf();

        // 计算30天后的时间戳用于筛选即将到期的贷款
        const thirtyDaysLater = this.moment().add(30, 'days').valueOf();

        const res = await loanList({
          account: this.account,
          dateFrom: dateFrom,
          dateTo: dateTo,
          status: [0, 2], // 状态为0和2的数据 (未还款和预警状态)
          page: 1,
          pageSize: 100
        });

        if (res.code === '0' && res.result && res.result.list) {
          console.log('res', res);
          // 筛选30天内到期的贷款
          const dueLoans = res.result.list.filter(loan => {
            // 贷款开始时间加一年就是到期时间
            const loanDate = new Date(loan.createdAt);
            const dueDate = new Date(loanDate);
            dueDate.setFullYear(dueDate.getFullYear() + 1);

            // 如果到期日期在当前时间和未来30天之内，则为即将到期
            const dueDateTimestamp = dueDate.getTime();
            const now = Date.now();
            return dueDateTimestamp > now && dueDateTimestamp <= thirtyDaysLater;
          });

          this.dueLoansCount = dueLoans.length;
          this.showDueLoans = this.dueLoansCount > 0;
          console.log('Due loans count:', this.dueLoansCount);
        }
      } catch (e) {
        console.error('获取即将到期贷款失败:', e);
      }
    },
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.loanStatusChart && this.loanStatusChart.resize();
      this.balanceChart && this.balanceChart.resize();
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.loanStatusChart && this.loanStatusChart.resize();
      this.balanceChart && this.balanceChart.resize();
    });
    this.loanStatusChart && this.loanStatusChart.dispose();
    this.balanceChart && this.balanceChart.dispose();
  },
  created() {
    this.init();
  },
  watch: {
    account(newVal) {
      if (newVal) {
        this.init();
      } else {
        this.balance = 0;
        this.depositeBalance = 0;
        this.overdraft = 0;
        this.warningTotal = 0;
      }
    }
  }
};
</script>
<style scoped lang="scss">
.assets {
  border: 1px solid #272D38;
  border-radius: 0.24rem;
  background: #FAFAFA;
  padding: 0.56rem;
  background: linear-gradient(90deg, #020202 0%, #020202 42%, #00266B 100%);

  .common-card {
    padding: 0.28rem 0.24rem;
    background: #001A49;
    position: relative;
    border-radius: 0.2rem;
    border: 1px solid rgba(255, 255, 255, .19);
  }

  .common-card-main {
    .el-button--text {
      color: #225BFC !important;
    }
  }

  ::v-deep  .el-button--medium {
    margin-left: 0.28rem;
    padding: 0.09rem 0.16rem;
    font-size: 0.16rem;
    border-radius: 0.04rem;

    &.el-button--primary {
      border: none;
      background: linear-gradient(90deg, #0E3491 0%, #225BFC 100%);
    }
  }

  // 添加repay now按钮样式
  .repay-now-btn {
    border-radius: 0.04rem;
    position: relative;

    &:active {
      transform: translateY(1px);
      opacity: 0.8;
    }
  }
}

.text-1 {
  font-size: 0.2rem;
  font-weight: 400;
  color: #DCE0E7;
}

.text-2 {
  font-size: 0.24rem;
  font-weight: 500;
  font-family: Roboto-Medium, Roboto;
  color: #929DAD;
  line-height: 1;

  .big-number {
    color: #fff;
    font-size: 0.48rem;
  }
}

.common-card {
  margin-top: 0.48rem;
}

.card-text-1 {
  font-size: 0.2rem;
  font-weight: 600;
  color: #DCE0E7;
  min-height: 0.36rem;

  i {
    margin-right: 0.12rem;
    font-size: .22rem !important;
  }
}

.card-text-2 {
  font-size: 0.24rem;
  font-weight: 500;
  margin-left: 0.34rem;
  font-family: Roboto-Medium, Roboto;
  color: #1f1f1f;
  margin-bottom: 0.18rem;

  .big-number {
    color: #fff;
    font-size: 0.24rem;
  }

  .unit {
    font-size: 0.16rem;
    font-weight: 500;
    font-family: Roboto-Regular, Roboto;
    color: #929DAD;
  }
}

.warn-btn {
  position: relative;
  background: #f0426c;
  color: #fff;
  border-color: #f0426c;

  &:focus {
    background: #e03e64;
    border-color: #e03e64;
  }

  svg {
    position: absolute;
    right: -0.06rem;
    top: -0.06rem;
  }

  // .el-tooltip.item {
  //   font-size: 0.12rem;
  // }
}

.echat {
  margin-top: 20px;
  background: #001A49;
  border-radius: 0.2rem;
  border: 1px solid rgba(255, 255, 255, .19);
  padding: 0.1rem;
  width: 45%;
}

.learn-more-dialog {
  background: #001A49 !important;
  border-radius: 0.2rem !important;
  border: 1px solid rgba(255, 255, 255, .19) !important;
  overflow: hidden !important;

  .el-dialog__header {
    background: #001A49 !important;
    padding: 20px 25px !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
    text-align: left;

    .dialog-custom-title {
      color: #1F1F1F !important;
      font-size: 0.28rem !important;
      font-weight: bold !important;
      font-family: HurmeGeometricSans2-Bold, sans-serif !important;
    }

    .el-dialog__headerbtn {
      top: 20px !important;
      right: 20px !important;

      .el-dialog__close {
        color: #ffffff !important;
        font-size: 0.2rem !important;
      }
    }
  }

  .el-dialog__body {
    background: #001A49 !important;
    padding: 25px 30px !important;
    color: #DCE0E7 !important;

    .learn-more-content {
      font-size: 0.22rem !important;
      line-height: 1.6 !important;
      font-weight: 500;
      color: #1F1F1F;
      font-family: PlusJakartaDisplay-Regular, PlusJakartaDisplay;
      // font-family: HurmeGeometricSans2-Regular;
      text-align: center;
    }
  }

  .el-dialog__footer {
    background: #001A49 !important;
    padding: 15px 25px 25px !important;

    .el-button {
      background: linear-gradient(90deg, #0E3491 0%, #225BFC 100%) !important;
      border: none !important;
      color: #ffffff !important;
      padding: 10px 24px !important;
      border-radius: 4px !important;
      font-size: 0.16rem !important;
      font-weight: 500 !important;
      transition: all 0.3s !important;

      &:hover {
        opacity: 0.9 !important;
        transform: translateY(-1px) !important;
      }
    }
  }
}
</style>
